import { css } from 'styled-components';
import {
  grid, gridUnit, SpacingName, ThemedFunctor,
} from '@doveit/lego';

export const list: ThemedFunctor = ({
  theme,
}) => css`
  ${grid(theme, {
    gutter: SpacingName.SMALLER,
  })}
`;

export const item: ThemedFunctor = ({
  theme,
  $columns,
}) => css`
  ${gridUnit(theme, {
    gutter: SpacingName.SMALLER,
    size: {
      XS: 1 / 2,
      MD: 1 / $columns,
    },
  })}
`;
